import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import store from './store/store';
import PrivateRoute from './components/common/PrivateRoute';
import ErrorBoundary from './app/ErrorBoundary';

// Layout Components
import AdminLayout from './components/layout/AdminLayout';

// Pages
import LoginPage from './pages/Auth/LoginPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import PackagesPage from './pages/Packages/PackagesPage';
import PackageDetailsPage from './pages/Packages/PackageDetailsPage';
import PackageFormPage from './pages/Packages/PackageFormPage';
import HotelsPage from './pages/Hotels/HotelsPage';
import HotelDetailsPage from './pages/Hotels/HotelDetailsPage';
import HotelFormPage from './pages/Hotels/HotelFormPage';
import BookingsPage from './pages/Bookings/BookingsPage';
import BookingDetailsPage from './pages/Bookings/BookingDetailsPage';
import UsersPage from './pages/Users/UsersPage';
import UserDetailsPage from './pages/Users/UserDetailsPage';
import LocationsPage from './pages/Locations/LocationsPage';
import ReportsPage from './pages/Reports/ReportsPage';
import SettingsPage from './pages/Settings/SettingsPage';
import NotificationsPage from './pages/Notifications/NotificationsPage';
import ModulesPage from './pages/Modules/ModulesPage';
import ContentManagementPage from './pages/Content/ContentManagementPage';
import PriceCalculator from './pages/Tools/PriceCalculator';
import PricingConfiguration from './pages/Tools/PricingConfiguration';
import FrontDeskSearchPage from './pages/FrontDesk/FrontDeskSearchPage';
import FlightQuoteRequestsPage from './pages/Flights/FlightQuoteRequestsPage';

// Theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    mode: 'light',
  },
});

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <AdminLayout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<DashboardPage />} />
                      <Route path="/packages" element={<PackagesPage />} />
                      <Route path="/packages/new" element={<PackageFormPage />} />
                      <Route path="/packages/:id" element={<PackageDetailsPage />} />
                      <Route path="/packages/:id/edit" element={<PackageFormPage />} />
                      <Route path="/hotels" element={<HotelsPage />} />
                      <Route path="/hotels/new" element={<HotelFormPage />} />
                      <Route path="/hotels/:id" element={<HotelDetailsPage />} />
                      <Route path="/hotels/:id/edit" element={<HotelFormPage />} />
                      <Route path="/bookings" element={<BookingsPage />} />
                      <Route path="/bookings/:id" element={<BookingDetailsPage />} />
                      <Route path="/flight-quotes" element={<FlightQuoteRequestsPage />} />
                      <Route path="/front-desk" element={<FrontDeskSearchPage />} />
                      <Route path="/users" element={<UsersPage />} />
                      <Route path="/users/:id" element={<UserDetailsPage />} />
                      <Route path="/locations" element={<LocationsPage />} />
                      <Route path="/price-calculator" element={<PriceCalculator />} />
                      <Route path="/pricing-configuration" element={<PricingConfiguration />} />
                      <Route path="/reports" element={<ReportsPage />} />
                      <Route path="/settings" element={<SettingsPage />} />
                      <Route path="/notifications" element={<NotificationsPage />} />
                      <Route path="/modules" element={<ModulesPage />} />
                      <Route path="/content" element={<ContentManagementPage />} />
                    </Routes>
                  </AdminLayout>
                </PrivateRoute>
              }
            />
            </Routes>
          </Router>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;

